/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
const awsmobile = {
  aws_project_region: "us-east-1",
  aws_cognito_identity_pool_id:
    "us-east-1:9c474685-c600-49ad-86fb-9c9004b9df64",
  // aws_cognito_identity_pool_id:
  // 'us-east-1:943e1ac4-d9e1-4cca-8209-438cc27094fb',
  aws_cognito_region: "us-east-1",
  aws_user_pools_id: "us-east-1_YXMkvxNoV",
  aws_user_pools_web_client_id: "6c5dht3bpu3089r87of7ae3ut6",
  oauth: {},
  aws_geo_mapName: "spirits-prd-platform-Here-map",
  aws_geo_mapIndexName: "spirits-prd-platform-Here-singleusePlaceindex",
  aws_appsync_graphqlEndpoint:
    "https://3qcmwy4qane3japrpqbhf4o6nm.appsync-api.us-east-1.amazonaws.com/graphql",
  aws_appsync_region: "us-east-1",
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
};
export default awsmobile;